export default "__VITE_ASSET__BdW_W50J__"